(function () {
    'use strict';

    angular.module('app').controller('CropperModalController', CropperModalController);

    CropperModalController.$inject = [
        '$rootScope',
        '$http',
        '$uibModal',
        '$uibModalInstance',
        '$q',
        'toastr',
        '$timeout',
        'image',
        'url'
    ];

    function CropperModalController($rootScope,
                                    $http,
                                    $uibModal,
                                    $uibModalInstance,
                                    $q,
                                    toastr,
                                    $timeout,
                                    image,
                                    url) {

        let vm = this;
        vm.image = image;
        vm.crop = crop;
        vm.cancel = cancel;

        /*const reader = new FileReader();
        reader.onload = function (evt) {
            $timeout(function(){
                vm.image=evt.target.result;
            });
        };
        reader.readAsDataURL(image);*/

        function crop() {
            $uibModalInstance.close(vm.croppedImage);
        }

        function cancel() {
            $uibModalInstance.dismiss(null);
        }
    }
})();


// WEBPACK FOOTER //
// ./js/controllers/CropperModalController.js